import { httpWithAuth } from '~/clients';
import { PRICING } from '~/constants/endpoints';
import type { PricingResponse } from '~/services/common/contracts';
import { BrowserCookies } from '~/utilities';

type OwnArgs = {
  clientId: string;
  correlationId: string;
  vehicleIds: number[];
  zip: string;
};

export default function fetchVehiclesPricing(
  { clientId, correlationId, vehicleIds, zip }: OwnArgs,
  controller: AbortController
) {
  return httpWithAuth.post<PricingResponse>(
    PRICING,
    {
      analyticsData: { clientId, correlationId, utmParams: {} },
      applyTradeIn: false,
      applyVerboseLogging: false,
      browserCookieId: BrowserCookies.get('BrowserCookieId') ?? '',
      preferredAcquisitionName: '',
      vehicleIds,
      zip5: zip
    },
    { signal: controller.signal }
  );
}
